import { render, staticRenderFns } from "./New-Asset.vue?vue&type=template&id=7218ab25&"
import script from "./New-Asset.vue?vue&type=script&lang=ts&"
export * from "./New-Asset.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports